import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "flex justify-content-start" }
const _hoisted_3 = { class: "flex justify-content-end" }
const _hoisted_4 = { class: "p-input-icon-left" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = {
  key: 0,
  class: "chart"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Chart = _resolveComponent("Chart")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_DataTable, {
        value: _ctx.countries,
        paginator: true,
        dataKey: "id",
        rows: 5,
        rowsPerPageOptions: [5, 10, 20, 50],
        paginatorTemplate: "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
        currentPageReportTemplate: "Showing {first} to {last} of {totalRecords}",
        filters: _ctx.filters,
        "onUpdate:filters": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters) = $event)),
        tableStyle: "min-width: 50rem"
      }, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_Button, {
              label: "Clear All Favourite",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.clearFav()))
            })
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, [
              _hoisted_5,
              _createVNode(_component_InputText, {
                modelValue: _ctx.filters['global'].value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters['global'].value) = $event)),
                placeholder: "Keyword Search"
              }, null, 8, ["modelValue"])
            ])
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_Column, {
            field: "favourite",
            header: "Favourite"
          }, {
            body: _withCtx((slotProps) => [
              _createVNode(_component_Checkbox, {
                modelValue: slotProps.data.favourite,
                "onUpdate:modelValue": ($event: any) => ((slotProps.data.favourite) = $event),
                binary: true,
                onClick: ($event: any) => (_ctx.addToFavourite(slotProps.data.id, slotProps.data.favourite))
              }, null, 8, ["modelValue", "onUpdate:modelValue", "onClick"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, { header: "Flag" }, {
            body: _withCtx((slotProps) => [
              _createElementVNode("img", {
                src: `${slotProps.data.flag}`,
                alt: slotProps.data.name,
                class: "w-6rem shadow-2 border-round"
              }, null, 8, _hoisted_6)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "name",
            sortable: "",
            header: "Name"
          }, {
            body: _withCtx((slotProps) => [
              _createElementVNode("span", {
                innerHTML: _ctx.highlightText(slotProps.data.name)
              }, null, 8, _hoisted_7)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "region",
            sortable: "",
            header: "Region"
          }, {
            body: _withCtx((slotProps) => [
              _createElementVNode("span", {
                innerHTML: _ctx.highlightText(slotProps.data.region)
              }, null, 8, _hoisted_8)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "capital",
            sortable: "",
            header: "Capital"
          }, {
            body: _withCtx((slotProps) => [
              _createElementVNode("span", {
                innerHTML: _ctx.highlightText(slotProps.data.capital)
              }, null, 8, _hoisted_9)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value", "filters"])
    ]),
    (_ctx.chartData)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createVNode(_component_Chart, {
            type: "bar",
            data: _ctx.chartData,
            options: _ctx.chartOptions,
            class: "h-30rem"
          }, null, 8, ["data", "options"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}